import React, { Component } from "react";

class Checkout extends Component {
  state = {
    name: "",
    email: "",
    phone: "",
    address: "",
    city: "",
    country: "",
    zip: "",
    subtotal: 120,
    shipping: 10,
    taxRate: 0.05,

    cardName: "",
    cardNumber: "",
    expiryMonth: "",
    expiryYear: "",
    cvv: "",
    billingAddress: ""
  };

  handleChange = (field, value) => {
    this.setState({ [field]: value });
  };

  goBack = () => {
    window.location.href = "/cart";
  };

  placeOrder = () => {
    console.log("Order Data:", this.state);
    alert("Order placed successfully!");
  };

  render() {
    const { subtotal, shipping, taxRate } = this.state;
    const tax = subtotal * taxRate;
    const total = subtotal + shipping + tax;

    return (
      <>
        <style>{`
          .smooth-hover { transition:.25s ease; }
          .smooth-hover:hover { transform:translateY(-2px); }

          /* Neon buttons – same as Login/SignUp screenshot */
          .neon-green-btn {
            background: linear-gradient(135deg, #32ff72, #46ff60);
            color: #0b1a23;
            padding: 12px 32px;
            border-radius: 40px;
            border: none;
            cursor: pointer;
            font-weight: 700;
            font-size: 15px;
            box-shadow: 0 4px 18px rgba(60,255,90,0.35);
            transition: 0.25s ease;
            display:inline-flex;
            align-items:center;
            gap:6px;
          }

          .neon-green-btn:hover {
            box-shadow: 0 4px 26px rgba(60,255,90,0.55);
            transform: translateY(-2px);
          }

          /* Inputs */
          .co-input {
            width:100%;
            padding:11px 12px;
            border-radius:12px;
            border:1px solid #d1d5db;
            background:rgba(255,255,255,0.75);
            font-size:14px;
            outline:none;
            transition:.2s;
          }
          .co-input:focus {
            border-color:#3b82f6;
            box-shadow:0 0 0 3px rgba(59,130,246,0.25);
            background:rgba(255,255,255,0.95);
          }

          .co-label {
            font-size:14px;
            font-weight:600;
            color:#1d3557;
            margin-bottom:5px;
            display:block;
          }

          /* Glass card wrapper */
          .co-shell {
            max-width:1000px;
            margin:0 auto;
            padding:25px 28px;
            background:rgba(255,255,255,0.06);
            border-radius:22px;
            border:1px solid rgba(255,255,255,0.18);
            backdrop-filter:blur(16px);
            -webkit-backdrop-filter:blur(16px);
            box-shadow:0 10px 40px rgba(0,0,0,0.35);
          }

          .co-section-card {
            background:rgba(255,255,255,0.84);
            border-radius:16px;
            padding:18px 18px 16px;
            border:1px solid #e2e8f0;
          }

          .co-summary-card {
            background:rgba(11,23,45,0.96);
            border-radius:16px;
            padding:18px;
            border:1px solid rgba(148,163,184,0.6);
            color:#e5e7eb;
          }

          .co-summary-row {
            font-size:15px;
            font-weight:600;
            line-height:1.9;
          }

          .co-summary-row span {
            float:right;
          }

          .co-summary-total {
            font-size:20px;
            font-weight:800;
            margin-top:6px;
            color:#f9fafb;
          }

          /* Responsive */
          @media (max-width:900px){
            .co-grid {
              grid-template-columns:1fr !important;
            }
          }
        `}</style>

        <div style={{ padding: "45px 0" }}>
          <div className="co-shell">
            {/* HEADER */}
            <div
              style={{
                background: "linear-gradient(135deg,#1d3557,#2c4e7a)",
                padding: "18px",
                borderRadius: "16px",
                marginBottom: "24px",
                textAlign: "center",
                color: "white",
                fontWeight: 700,
                fontSize: "24px",
                letterSpacing: ".5px",
                boxShadow: "0 0 25px rgba(15,23,42,0.7)"
              }}
            >
              Checkout
            </div>

            <form>
              {/* GRID LAYOUT */}
              <div
                className="co-grid"
                style={{
                  display: "grid",
                  gridTemplateColumns: "2fr 1.1fr",
                  gap: "24px"
                }}
              >
                {/* LEFT – BILLING + CARD */}
                <div>
                  {/* Billing info */}
                  <div className="co-section-card" style={{ marginBottom: "20px" }}>
                    <h3
                      style={{
                        fontSize: "18px",
                        fontWeight: 700,
                        marginBottom: "14px",
                        color: "#1d3557"
                      }}
                    >
                      Billing Information
                    </h3>

                    <label className="co-label">Full Name</label>
                    <input
                      type="text"
                      className="co-input"
                      onChange={(e) => this.handleChange("name", e.target.value)}
                    />

                    <label className="co-label">Email</label>
                    <input
                      type="email"
                      className="co-input"
                      onChange={(e) => this.handleChange("email", e.target.value)}
                    />

                    <label className="co-label">Phone</label>
                    <input
                      type="text"
                      className="co-input"
                      onChange={(e) => this.handleChange("phone", e.target.value)}
                    />

                    <label className="co-label">Address</label>
                    <input
                      type="text"
                      className="co-input"
                      onChange={(e) => this.handleChange("address", e.target.value)}
                    />

                    <div style={{ display: "flex", gap: "10px" }}>
                      <div style={{ flex: 1 }}>
                        <label className="co-label">City</label>
                        <input
                          type="text"
                          className="co-input"
                          onChange={(e) =>
                            this.handleChange("city", e.target.value)
                          }
                        />
                      </div>

                      <div style={{ flex: 1 }}>
                        <label className="co-label">Country</label>
                        <input
                          type="text"
                          className="co-input"
                          onChange={(e) =>
                            this.handleChange("country", e.target.value)
                          }
                        />
                      </div>

                      <div style={{ flex: 1 }}>
                        <label className="co-label">ZIP Code</label>
                        <input
                          type="text"
                          className="co-input"
                          onChange={(e) =>
                            this.handleChange("zip", e.target.value)
                          }
                        />
                      </div>
                    </div>
                  </div>

                  {/* Card details */}
                  <div className="co-section-card">
                    <h3
                      style={{
                        fontSize: "18px",
                        fontWeight: 700,
                        marginBottom: "14px",
                        color: "#1d3557"
                      }}
                    >
                      Card Payment Details
                    </h3>

                    <label className="co-label">Card Holder Name</label>
                    <input
                      type="text"
                      placeholder="Name on card"
                      className="co-input"
                      onChange={(e) =>
                        this.handleChange("cardName", e.target.value)
                      }
                    />

                    <label className="co-label">Card Number</label>
                    <input
                      type="text"
                      maxLength="19"
                      placeholder="1234 5678 9012 3456"
                      className="co-input"
                      onChange={(e) =>
                        this.handleChange("cardNumber", e.target.value)
                      }
                    />

                    <div style={{ display: "flex", gap: "10px" }}>
                      <div style={{ flex: 1 }}>
                        <label className="co-label">Expiry Month</label>
                        <input
                          type="text"
                          maxLength="2"
                          placeholder="MM"
                          className="co-input"
                          onChange={(e) =>
                            this.handleChange("expiryMonth", e.target.value)
                          }
                        />
                      </div>
                      <div style={{ flex: 1 }}>
                        <label className="co-label">Expiry Year</label>
                        <input
                          type="text"
                          maxLength="2"
                          placeholder="YY"
                          className="co-input"
                          onChange={(e) =>
                            this.handleChange("expiryYear", e.target.value)
                          }
                        />
                      </div>
                      <div style={{ flex: 1 }}>
                        <label className="co-label">CVV</label>
                        <input
                          type="password"
                          maxLength="4"
                          placeholder="***"
                          className="co-input"
                          onChange={(e) =>
                            this.handleChange("cvv", e.target.value)
                          }
                        />
                      </div>
                    </div>

                    <label className="co-label">Billing Address (Optional)</label>
                    <input
                      type="text"
                      placeholder="Street, House no..."
                      className="co-input"
                      onChange={(e) =>
                        this.handleChange("billingAddress", e.target.value)
                      }
                    />
                  </div>
                </div>

                {/* RIGHT – SUMMARY */}
                <div>
                  <div className="co-summary-card">
                    <h3
                      style={{
                        fontSize: "18px",
                        fontWeight: 700,
                        marginBottom: "14px",
                        color: "#e5e7eb"
                      }}
                    >
                      Order Summary
                    </h3>

                    <div className="co-summary-row">
                      Subtotal:
                      <span>${subtotal.toFixed(2)}</span>
                    </div>
                    <div className="co-summary-row">
                      Tax (5%):
                      <span>${tax.toFixed(2)}</span>
                    </div>
                    <div className="co-summary-row" style={{ marginBottom: 8 }}>
                      Shipping:
                      <span>${shipping.toFixed(2)}</span>
                    </div>

                    <hr style={{ borderColor: "rgba(148,163,184,0.5)" }} />

                    <div className="co-summary-total">
                      Total:
                      <span>${total.toFixed(2)}</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* BOTTOM BUTTONS */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "26px",
                  gap: "14px",
                  flexWrap: "wrap"
                }}
              >
                <button
                  type="button"
                  onClick={this.goBack}
                  className="neon-green-btn"
                >
                  ← Back to Cart
                </button>

                <button
                  type="button"
                  onClick={this.placeOrder}
                  className="neon-green-btn"
                >
                  Place Order →
                </button>
              </div>
            </form>
          </div>
        </div>
      </>
    );
  }
}

export default Checkout;
